import { SINGLE_PRIZE } from "@/lib/constants";
import { motion } from "framer-motion";
import { Sparkles, MapPin, ExternalLink, Trophy } from "lucide-react";
import { Link } from "react-router-dom";

type Variant = "hero" | "ranking";

export function SinglePrizeBanner({ variant = "hero" }: { variant?: Variant }) {
  const compact = variant === "hero";

  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      className="relative overflow-hidden rounded-lg shadow-pop bg-gold p-4"
    >
      <div className="absolute -right-4 -top-4 text-7xl opacity-15 select-none">🧖</div>
      <div className="absolute -right-10 bottom-2 text-6xl opacity-10 select-none">🏔️</div>

      <div className="flex items-center gap-2 mb-1">
        <span className="inline-flex items-center gap-1 bg-foreground/90 text-background rounded-pill px-2 py-0.5 text-[10px] font-bold uppercase tracking-wider">
          <Trophy className="h-3 w-3" /> Einzel-Hauptpreis
        </span>
        <span className="text-[10px] font-bold uppercase tracking-wider opacity-70">
          Sieger:in Gesamtwertung
        </span>
      </div>

      <h2 className="font-display font-extrabold text-lg leading-tight flex items-center gap-1.5">
        <Sparkles className="h-5 w-5 shrink-0" />
        Wellnessurlaub für 2 Personen
      </h2>
      <div className="text-sm font-bold mt-0.5">
        {SINGLE_PRIZE.nights} Nächte · {SINGLE_PRIZE.hotel}
      </div>
      <div className="text-[11px] flex items-center gap-1 opacity-80 mt-0.5">
        <MapPin className="h-3 w-3" /> {SINGLE_PRIZE.location}
      </div>

      {!compact && (
        <ul className="mt-3 space-y-1 text-[12px] font-medium relative">
          {SINGLE_PRIZE.highlights.map((h) => (
            <li key={h} className="flex items-start gap-1.5">
              <span className="mt-0.5">✦</span>
              <span>{h}</span>
            </li>
          ))}
        </ul>
      )}

      <div className="mt-3 flex items-center gap-2 relative">
        {compact ? (
          <Link
            to="/ranking?tab=single"
            className="bg-foreground text-background rounded-pill px-3 py-1.5 text-xs font-bold tap"
          >
            Zum Einzel-Ranking →
          </Link>
        ) : (
          <a
            href={SINGLE_PRIZE.url}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-1 bg-foreground text-background rounded-pill px-3 py-1.5 text-xs font-bold tap"
          >
            Hotel ansehen <ExternalLink className="h-3 w-3" />
          </a>
        )}
        <span className="text-[10px] opacity-70">Vergabe nach dem Finale</span>
      </div>
    </motion.div>
  );
}
